import moment from 'moment';
import React from 'react';

const TimeColumn = ({ value = 0 }: { value: number }) => {
    return <span>{moment(value).format('MMM DD, YYYY h:mm a') || '--'}</span>;
};

export default TimeColumn;
